import "@wingspanhq/fe-component-library/dist/style.css";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { PATH_PAYMENT } from "../../modules/PaymentApp/paths";
import { PaymentApp } from "../../modules/PaymentApp";
import "../../global.scss";
import { OAUTH_ROOT_PATH, OAuthIndex } from "../../modules/OAuth";
import { SignOut } from "../../screens/SignOut";
import { MemberApp } from "./MemberApp";
import { Providers } from "./Providers";

const App: React.FC = () => (
  <Providers>
    <Switch>
      <Route
        path={["/sign-out", "/signout", "/log-out", "/logout"]}
        exact
        component={SignOut}
      />
      <Route path={OAUTH_ROOT_PATH} component={OAuthIndex} />

      <Redirect from="/invoice-payment/:invoiceId" to="/payment/:invoiceId" />
      <Redirect from="/i/:invoiceId" to="/payment/:invoiceId" />
      <Redirect from="/p/:invoiceId" to="/payment/:invoiceId" />
      <Redirect from="/pay/:tag" to="/payment/ppl/:tag" />
      <Redirect from="/ppl/:tag" to="/payment/ppl/:tag" />

      <Route path={PATH_PAYMENT} component={PaymentApp} />
      <Route component={MemberApp} />
    </Switch>
  </Providers>
);

export default App;
